import { InjectionToken } from '@angular/core';

import type { AmpAppShellConfig } from './app-shell.model';

export const AMP_APP_SHELL_CONFIG = new InjectionToken<AmpAppShellConfig>(
  'AMP_APP_SHELL_CONFIG',
);
